import React from "react";
import { cutoffs, colors } from "./PerformanceSummary";
import { DragonType, JungleCampName, StructureTier, Team } from "../types/snapshot/Enums";
import { StructureName } from "../types/all-game-data/Enums";
import BlueTurret from '../icons/blue_turret.png';
import RedTurret from '../icons/red_turret.png';
import BlueInhib from '../icons/blue_inhib.png';
import RedInhib from '../icons/red_inhib.png';
import Baron from '../icons/baron.png';
import Herald from '../icons/herald.png';
import Horde from '../icons/horde.png';
import DragonElder from '../icons/dragon_elder.png';
import DragonCloud from '../icons/dragon_cloud.png';
import DragonMountain from '../icons/dragon_mountain.png';
import DragonInfernal from '../icons/dragon_infernal.png';
import DragonOcean from '../icons/dragon_ocean.png';
import DragonHextech from '../icons/dragon_hextech.png';
import DragonChemtech from '../icons/dragon_chemtech.png';
import Kill from '../icons/scoreboard_kill.png';
var kills = React.createElement("img", { src: Kill, alt: " ", style: { width: 15, height: 19, marginRight: 5 }, draggable: false });
var iconDim = 25;
function capitalize(string) {
    if (typeof string !== 'string' || string.length === 0) {
        return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var SingleEvent = function (_a) {
    var _b;
    var gameData = _a.gameData, event = _a.event, championSummary = _a.championSummary;
    if (!gameData || !event) {
        return null;
    }
    var diff = event.winrateDiff > 0 ? "+".concat(event.winrateDiff.toFixed(2), "%") : "".concat(event.winrateDiff.toFixed(2), "%");
    var color = colors[cutoffs.findIndex(function (cutoff) { return event.winrateDiff >= cutoff; })];
    var participantChampionIcons = event.participantChampionNames.map(function (championName, i) {
        var _a;
        var id = (_a = championSummary.find(function (champion) { return champion.alias.toLowerCase() === championName; })) === null || _a === void 0 ? void 0 : _a.id;
        var src = id ? "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/".concat(id, ".png") : championName;
        var color = event.participantTeam === Team.BLUE ? 'rgb(0, 163, 240)' : 'rgb(230, 10, 20)';
        var championKill = Object.values(gameData.allyRoles).concat(Object.values(gameData.enemyRoles)).includes(event.victimName);
        return React.createElement("img", { key: i, src: src, alt: championName, style: { width: iconDim, height: iconDim, boxSizing: 'content-box', borderRadius: '50%', marginRight: 5, border: "".concat(championKill && i === event.participantChampionNames.length - 1 ? '3px' : '2px', " solid ").concat(color) }, draggable: false });
    });
    var victimIcon;
    var victimText;
    if (StructureName.isTurret(event.victimName)) {
        var _c = StructureName.convert(event.victimName), team = _c[0], lane = _c[1], tier = _c[2], type = _c[3];
        var src = team === 'blue' ? BlueTurret : RedTurret;
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, marginRight: 5 }, draggable: false });
        var text = (tier === StructureTier.NEXUS_1 || tier === StructureTier.NEXUS_2) ? 'Nexus' : "".concat(capitalize(lane), " ").concat(capitalize(tier));
        var color_1 = team === 'blue' ? 'rgb(0, 163, 240)' : 'rgb(230, 10, 20)';
        victimText = React.createElement("div", { style: { fontSize: 12, color: color_1 } }, text);
    }
    else if (StructureName.isInhib(event.victimName)) {
        var _d = StructureName.convert(event.victimName), team = _d[0], lane = _d[1], tier = _d[2], type = _d[3];
        var src = team === 'blue' ? BlueInhib : RedInhib;
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, marginRight: 5 }, draggable: false });
        var text = "".concat(capitalize(lane));
        var color_2 = team === 'blue' ? 'rgb(0, 163, 240)' : 'rgb(230, 10, 20)';
        victimText = React.createElement("div", { style: { fontSize: 12, color: color_2 } }, text);
    }
    else if (event.victimName === JungleCampName.BARON) {
        var src = Baron;
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, marginRight: 5 }, draggable: false });
    }
    else if (event.victimName === JungleCampName.RIFT_HERALD) {
        var src = Herald;
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, marginRight: 5 }, draggable: false });
    }
    else if (event.victimName === JungleCampName.GRUB_1 || event.victimName === JungleCampName.GRUB_2 || event.victimName === JungleCampName.GRUB_3) {
        var src = Horde;
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, marginRight: 5 }, draggable: false });
    }
    else if (event.victimName.endsWith('dragon')) {
        var _e = event.victimName.split(' '), type = _e[0], dragon = _e[1];
        var src = void 0;
        switch (type) {
            case DragonType.CLOUD:
                src = DragonCloud;
                break;
            case DragonType.MOUNTAIN:
                src = DragonMountain;
                break;
            case DragonType.INFERNAL:
                src = DragonInfernal;
                break;
            case DragonType.OCEAN:
                src = DragonOcean;
                break;
            case DragonType.HEXTECH:
                src = DragonHextech;
                break;
            case DragonType.CHEMTECH:
                src = DragonChemtech;
                break;
            case DragonType.ELDER:
                src = DragonElder;
                break;
            default:
                src = DragonCloud;
                break;
        }
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, marginRight: 5 }, draggable: false });
    }
    else {
        var id = (_b = championSummary.find(function (champion) { return champion.alias.toLowerCase() === event.victimName; })) === null || _b === void 0 ? void 0 : _b.id;
        var src = id ? "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/".concat(id, ".png") : event.victimName;
        var color_3 = event.victimTeam === Team.BLUE ? 'rgb(0, 163, 240)' : 'rgb(230, 10, 20)';
        victimIcon = React.createElement("img", { src: src, alt: event.victimName, style: { width: iconDim, height: iconDim, borderRadius: '50%', border: "2px solid ".concat(color_3), marginRight: 5 }, draggable: false });
    }
    return (React.createElement("div", { style: { width: '100%', height: 35, flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
        React.createElement("div", { style: { flex: 4, height: '100%', display: 'flex', alignItems: 'center', paddingLeft: 15 } },
            participantChampionIcons,
            kills,
            victimIcon,
            victimText),
        React.createElement("div", { style: { flex: 1, height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', color: color, fontSize: 14, marginRight: 15 } }, diff)));
};
export default SingleEvent;
